import styled from 'styled-components';

export const Input = styled.input`
  display: none;
`;

export const Label = styled.label`
  display: flex;
  text-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  padding: 9px 14px;
  cursor: pointer;
  transition: background-color 0.1s;
  font-weight: ${(p) => p.theme.font.weight.bold};
  border-radius: ${(p) => p.theme.radius.default};
  background-color: ${(p) => p.theme.colors.grey[100]};
  font-size: ${(p) => p.theme.font.size.xxs};
  &:hover {
    background-color: ${(p) => p.theme.colors.grey[300]};
  }
`;

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ImagePreviewContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: ${(p) => p.theme.shadows.sm};
`;

export const CloseIconContainer = styled.div`
  position: absolute;
  right: ${(p) => p.theme.spacing.sm};
  top: ${(p) => p.theme.spacing.sm};
`;

export const ImagePreview = styled.img`
  width: 100%;
  display: block;
  object-fit: cover;
`;
